export const UNSTAKE_TRANSACTION_BEGIN_LEARN_MORE_URL = 'https://support.stride.zone/library/how-to-swap-on-osmosis'
export const STAKING_STEP_ONE = 0
export const STAKING_STEP_TWO = 1
export const STAKING_STEP_THREE = 2
export const STAKING_STEP_FOUR = 3
